import { createAction, props } from '@ngrx/store';

import { UserOrganization } from '../domain/user-organization';
import {
	LanguagePreference,
	UserPreference,
	ViewMode,
} from '../domain/user-preference';
import { UserProfile } from '../domain/user-profile';
import {InstanceModule} from "../domain/instance-module";
import {Map} from 'immutable';

export enum CoreAction {
	GetOrganization = '[Core] Get organization',
	GetOrganizationSuccess = '[Core] Get organization success',
	GetOrganizationFail = '[Core] Get organization fail',
	GetCurrentUserSuccess = '[Core] Get current user success',
	GetConnectedUserSuccess = '[Core] Get connected user success',
	GetConnectedUserFail = '[Core] Get connected user fail',
	SwitchViewMode = '[Core] Switch view mode',
	NavigateToProfile = '[Core] Navigate to profile',
	SetAppLanguage = '[Core] Sync stored language config with user preference',
}

export const setAppLanguage = createAction(
	CoreAction.SetAppLanguage,
	props<{ lang: LanguagePreference }>(),
);

export const getOrganization = createAction(
	CoreAction.GetOrganization,
	props<{ organization: UserOrganization }>(),
);

export const getOrganizationSuccess = createAction(
	CoreAction.GetOrganizationSuccess,
	props<{ organization: UserOrganization }>(),
);

export const getOrganizationFail = createAction(
	CoreAction.GetOrganizationFail,
	props<{ error: unknown }>(),
);

export const getDetailsForConnectedUser = createAction(
	CoreAction.GetCurrentUserSuccess,
	props<{ user: UserProfile; preferredLang: string }>(),
);

export const getDetailsForConnectedUserSuccess = createAction(
	CoreAction.GetConnectedUserSuccess,
	props<{
		defaultOrganizationId: number;
		organizationPerUserAccount: UserOrganization;
		userMarketplacePreferences: UserPreference;
		instanceModules: Map<number, InstanceModule>;
	}>(),
);

export const getConnectedUserFail = createAction(
	CoreAction.GetConnectedUserFail,
	props<{ error: unknown }>(),
);

export const switchViewMode = createAction(
	CoreAction.SwitchViewMode,
	props<{ viewMode: ViewMode }>(),
);

export const goToConnectedUserProfile = createAction(
	CoreAction.NavigateToProfile,
);
